import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "row mb-8"
}
const _hoisted_2 = { class: "col-12 mb-5" }
const _hoisted_3 = { class: "h-100 d-flex flex-column justify-content-between" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", {
  "aria-hidden": "true",
  class: "spinner-border spinner-border-sm"
}, null, -1)
const _hoisted_7 = { class: "btn-text" }
const _hoisted_8 = {
  key: 0,
  class: "col-12 mb-5"
}
const _hoisted_9 = { class: "table-responsive" }
const _hoisted_10 = { class: "table table-row-bordered table-hover align-middle mb-0" }
const _hoisted_11 = { class: "fw-bold fs-6 text-gray-800" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("th", null, "Action", -1)
const _hoisted_13 = ["onClick"]
const _hoisted_14 = /*#__PURE__*/_createElementVNode("i", { class: "ms-1 fa-solid fa-download" }, null, -1)
const _hoisted_15 = [
  _hoisted_14
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FileInput = _resolveComponent("FileInput")!
  const _component_BasicCard = _resolveComponent("BasicCard")!

  return (_ctx.infos?.documents && Object.keys(_ctx.infos?.documents).length)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", null, [
              (_ctx.infos.documents?.cv?.length)
                ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(_ctx.$t('views.portal.search.cvArea.card.uploadArea.uploaded')), 1))
                : (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(_ctx.$t('views.portal.search.cvArea.card.uploadArea.notUploaded')), 1)),
              _createVNode(_component_FileInput, {
                onOnUpload: _cache[0] || (_cache[0] = ($event: any) => (_ctx.handleFileUpload('cv', $event))),
                name: "cv",
                errors: _ctx.uploadErrors.cv,
                errorFileType: _ctx.uploadFileType.cv,
                accept: "application/pdf"
              }, null, 8, ["errors", "errorFileType"]),
              _createElementVNode("button", {
                type: "button",
                class: _normalizeClass(["btn btn-primary btn-violet animated-submit mt-5", { disabled: _ctx.isSubmitting }]),
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.submitFiles && _ctx.submitFiles(...args)))
              }, [
                _hoisted_6,
                _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.$t('global.buttons.send')), 1)
              ], 2)
            ])
          ])
        ]),
        (_ctx.infos?.documents?.cv?.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createVNode(_component_BasicCard, {
                "no-inline-border": "",
                "explicit-containment": "",
                class: "mb-5"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("table", _hoisted_10, [
                      _createElementVNode("thead", null, [
                        _createElementVNode("tr", _hoisted_11, [
                          _createElementVNode("th", null, _toDisplayString(_ctx.$t('views.portal.search.cvArea.card.uploadedList.name')), 1),
                          _createElementVNode("th", null, _toDisplayString(_ctx.$t('views.portal.search.cvArea.card.uploadedList.date')), 1),
                          _hoisted_12
                        ])
                      ]),
                      _createElementVNode("tbody", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.infos.documents.cv, (cv, index) => {
                          return (_openBlock(), _createElementBlock("tr", {
                            key: cv.fileId
                          }, [
                            _createElementVNode("td", null, "CV " + _toDisplayString(_ctx.infos.documents.cv.length - index), 1),
                            _createElementVNode("td", null, _toDisplayString(_ctx.formatDate(cv.uploadDate)), 1),
                            _createElementVNode("td", null, [
                              _createElementVNode("button", {
                                type: "button",
                                onClick: ($event: any) => (_ctx.download($event, cv.fileUrl)),
                                class: "btn btn-sm btn-primary btn-violet",
                                title: "Télécharger"
                              }, _hoisted_15, 8, _hoisted_13)
                            ])
                          ]))
                        }), 128))
                      ])
                    ])
                  ])
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}